import React from "react";
import * as FiIcons from "react-icons/fi";
import SafeIcon from "../common/SafeIcon";

const { FiAlertTriangle, FiArrowUp, FiMinus, FiArrowDown } = FiIcons;

const PriorityBadge = ({ priority, size = "sm" }) => {
  const normalizedPriority = priority?.toLowerCase() || "medium";

  const priorityConfig = {
    urgent: {
      label: "Urgent",
      color: "bg-red-900/40 text-red-300 border-red-500/30",
      icon: FiAlertTriangle,
    },
    high: {
      label: "High",
      color: "bg-orange-900/40 text-orange-300 border-orange-500/30",
      icon: FiArrowUp,
    },
    medium: {
      label: "Medium",
      color: "bg-yellow-900/30 text-yellow-300 border-yellow-500/30",
      icon: FiMinus,
    },
    low: {
      label: "Low",
      color: "bg-green-900/30 text-green-300 border-green-500/30",
      icon: FiArrowDown,
    },
  };

  const config = priorityConfig[normalizedPriority] || priorityConfig.medium;
  const sizeClasses = size === "sm" ? "text-xs px-2 py-1" : "text-sm px-3 py-1";

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium border ${config.color} ${sizeClasses}`}
    >
      <SafeIcon icon={config.icon} className="w-3 h-3" />
      {config.label}
    </span>
  );
};

export default PriorityBadge;
